import React, { useState } from 'react'
import {
    ebanxPay
} from '../../../../../../../api'
import { useApp } from '../../../../../../hooks/common'
import useCreditPay from '../hooks/credit-pay'

export default Wrapped => {

    return props => {

        const {
            payMethod,
            creditOrder,
            onError
        } = props

        const isApp = useApp()

        const {
            pay,
            paying,
            canPay
        } = useCreditPay({
            onError
        })

        const [submiting, setSubmiting] = useState(false)

        const handleSubmit = async (payment, installments) => {
            setSubmiting(true)

            const couldPay = await canPay()

            if(!couldPay){
                window.location.href = `/order-confirm/${creditOrder?.order?.transactionId}?transactionId=${creditOrder?.order?.transactionId}`
                return
            }


            const response = await ebanxPay({
                orderId: creditOrder?.order?.id,
                payMethod: payMethod,
                ...payment,
                installments
            })

            if (response?.code === 200 && response?.result) {
                const { transactionId, orderId, success, warnMsg, noticeType } = response?.result

                if (success) {
                    window.location.href = `/order-confirm/${transactionId}?transactionId=${transactionId}`
                } else {
                    const errorMessage = warnMsg || 'Network Error'
                    if (isApp) {
                        window.location.href = `/geekopay/app-fail?errMsg=${encodeURIComponent(errorMessage)}&selectPayment=1&noticeType=${noticeType}`
                    } else {
                        onError({
                            message: errorMessage,
                            noticeType,
                        })
                    }
                }
            } else {
                if (isApp) {
                    window.location.href = `/geekopay/app-fail?errMsg=${encodeURIComponent(response?.result || 'Network Error')}`
                } else {
                    onError({
                        message: response?.result || 'Network Error'
                    })
                }
            }

            setSubmiting(false)
        }

        const handleCredit = async (e, installments) => {
            e.preventDefault()
            setSubmiting(true)
            const couldPay = await canPay()

            if(!couldPay){
                window.location.href = `/order-confirm/${creditOrder?.order?.transactionId}?transactionId=${creditOrder?.order?.transactionId}`
                return
            }
            
            await pay({ installments })
            setSubmiting(false)
        }


        return <Wrapped {...props}
            submiting={submiting}
            handleSubmit={handleSubmit}
            handleCredit={handleCredit}
        />
    }
}